import { CourseInfo } from "../../../types/course";
import { formatCurrencyToVND } from "../../../utils/functionUltils";
import { commonMedia } from "./grapesjs-config";
import { renderTeacher } from "./grapesjs-service";
export const nameCategoryBlocks = "Khối giao diện";
export const nameCategoryTemplates = "Mẫu hoàn chỉnh";
export const nameContactBlock = "Khối liên hệ";
export const nameLinkedCourseBlock = "Khối khóa học mẫu";
export const nameLecturersBlock = "Khối giảng viên";
export const nameBasicBlock = "Giao diện cơ bản";
export const nameCountBlocks = "Khối thống kê mẫu";
export const nameRoadMapBlocks = "Khối lộ trình khóa học";
export const nameHeaderBlocks = "Giới thiệu chung";
export const nameRegisterBlocks = "Khối ghi danh";
export const nameConditionBlocks = "Khối điều kiện";
export const nameAffiliatedBlocks = "Khối liên kết";

export const generalContentIntroduction = (data?: any) => {
  const blockUI = {
    id: "content-block-id",
    label: "Phần nội dung",
    css: "",
    content: "",
    media: commonMedia,
    category: nameHeaderBlocks,
  };

  blockUI.content = `
    <section id="izqjjv" class="text-gray-600 body-font" component-class="generalIntro">
      <div id="ii6huh" class="container mx-auto flex px-5 flex-col items-center py-32 hero-bg">
        <div class="flex">
        <div id="ih954f" class="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center p-8 rounded">
          <h1 id="i2x7jy" class="title-font sm:text-4xl text-3xl font-medium mb-16 leading-loose">Nền tảng cung cấp khoá học mở đại chúng
            <br/>cung cấp bởi <span component-class="universityName">Đại học Bách khoa Hà Nội</span>
          </h1>
          <p id="ig3by3" class="mb-8 leading-relaxed text-gray-700">${
            process.env.REACT_APP_PROJECT_NAME || ""
          } là hệ thống cung cấp các khoá học được phát triển hợp tác cùng các trường đại học lớn trên toàn quốc.
            <br/><span component-class="universityName">Đại học Bách khoa Hà Nội</span> là trường đi đầu trong lĩnh vực giáo dục trực tuyến với hơn 200 khoá học cho sinh viên trên cả nước. Sinh viên sẽ được chứng nhận và cấp chứng chỉ bởi <span component-class="universityName">Đại học Bách khoa Hà Nội</span>.
          </p>

          <div id="i32hjp" class="flex w-full md:justify-start items-end" component-class="searchCourseInput"></div>

          <p id="iz1wvh" class="text-sm mt-2 mb-8 w-full text-gray-600">Xem thêm Chính sách quyền riêng tư.
          </p>
        </div>
        <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img alt="hero" src="https://s3.svhoc.com/dev-stable/page-builder/4/2024-06-13T09%3A18%3A27.119639196Z/3a80b404-c39d-4b20-98f6-9a77c99ee3ab360_F_457982937_r91A5qcFo2rUxnodlS2kRO20xkxV4cD7.jpg" id="i6rsrk" class="object-cover object-center rounded w-full"/>
        </div>
        </div>
        
      </div>
    </section>
  `;

  return blockUI;
};

export const generalCoursePopular = (data?: any) => {
  const blockUI = {
    id: "course-popular-id",
    label: "Khoá học nổi bật",
    css: "",
    content: "",
    media: commonMedia,
    category: nameHeaderBlocks,
  };

  const courses = data?.courses;

  const coursesRender = courses
    ?.map(
      (
        item: CourseInfo
      ) => `<div class="bg-white rounded-lg shadow-md overflow-hidden">
            <img src=${
              item?.thumbnailUrl || "https://via.placeholder.com/300x200"
            } 
            alt="Khóa học" class="w-full h-48 object-cover" 
            />
            <div class="p-4">
              <h3 class="text-sm text-gray-500 uppercase font-semibold">${
                item?.universityName
              } (${item?.slug})</h3>
              <h2 class="text-xl font-bold text-gray-800 mt-2">${
                item?.name
              }</h2>
              <p class="text-red-500 font-semibold mt-2">${formatCurrencyToVND(
                item?.cost
              )}</p>
              <p class="text-gray-600 text-sm mt-1">Giảng viên: ${renderTeacher(
                item?.teachers as string[]
              )}</p>

                <!-- Thông tin bổ sung -->
                <div class="flex items-center justify-between mt-4">
                  <span class="bg-green-100 text-green-800 text-xs font-medium px-3 py-1 rounded-full">Thịnh hành</span>
                  <span class="flex text-yellow-500 text-sm gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 .587l3.668 7.431 8.209 1.209-5.938 5.788 1.408 8.197-7.347-3.86-7.347 3.86 1.408-8.197-5.938-5.788 8.209-1.209z" />
                    </svg>
                    ${item?.avgStar}
                  </span>
                  <span class="text-blue-500 text-sm">${
                    item?.totalStudents
                  } học viên</span>
                </div>       
            </div> 
          </div>`
    )
    .join("");

  blockUI.content = `
    <div class="container mx-auto p-6" component-class="coursesPopular">
      <!-- Tiêu đề -->
      <div class="text-center">
        <h1 class="title-font sm:text-4xl text-3xl font-medium font-bold text-gray-800">Bắt đầu với những khoá học nổi bật</h1>
        <p class="text-gray-600 mt-3 mb-20">
          Hệ thống phát triển nền tảng cung cấp khoá học trực tuyến mở cùng với đa dạng khoá học ở nhiều lĩnh vực khác nhau
        </p>
      </div>

      <!-- Danh sách khoá học -->
      <div class="mt-8">
        <h2 class="text-2xl font-bold text-gray-800 mb-4">Các khoá học nổi bật</h2>

        <!-- Grid hiển thị khoá học -->
        ${
          courses?.length > 0
            ? `<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        ${coursesRender}   
        </div>`
            : `<div class="text-center">Không có khoá học</div>`
        }
        
      </div>

      <div class="mt-40 mb-40">
        <div class="container mx-auto text-center">
          <!-- Tiêu đề -->
          <h1 class="title-font sm:text-4xl text-3xl font-medium font-bold text-gray-800">Hệ thống học tập trực tuyến Mooc</h1>
          <p class="text-gray-600 mt-2">
            Nền tảng trực tuyến mở cung cấp đa dạng khoá học được tin tưởng
          </p>

          <!-- Thông tin thống kê -->
          <div class="bg-gray-50 mt-8 p-6 rounded-lg shadow-sm">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
              <!-- Thống kê 1 -->
              <div>
                <h2 class="text-4xl font-bold text-rose-600">10k</h2>
                <p class="text-gray-700 mt-2">Khoá học trên hệ thống</p>
              </div>
              <!-- Thống kê 2 -->
              <div>
                <h2 class="text-4xl font-bold text-rose-600">200%</h2>
                <p class="text-gray-700 mt-2">Người dùng đăng ký mới sau 01 tháng ra mắt</p>
              </div>
              <!-- Thống kê 3 -->
              <div>
                <h2 class="text-4xl font-bold text-rose-600">100+</h2>
                <p class="text-gray-700 mt-2">Trường đại học liên kết</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`;

  return blockUI;
};

export const generalCoursesToStart = (data?: any) => {
  const blockUI = {
    id: "course-start-id",
    label: "Khoá học để bạn bắt đầu",
    css: "",
    content: "",
    media: commonMedia,
    category: nameHeaderBlocks,
  };

  blockUI.content = `
    <div class="container mx-auto p-6 mb-20" component-class="coursesToStart">
      <!-- Tiêu đề -->
      <div class="text-center">
        <h1 class="title-font sm:text-4xl text-3xl font-medium font-bold text-gray-800">Khoá học để bạn bắt đầu</h1>
        <p class="text-gray-600 mt-3 mb-20">
          Hệ thống phát triển nền tảng cung cấp khoá học trực tuyến mở cung cấp mở với đa dạng khoá học ở nhiều lĩnh vực khác nhau
        </p>
      </div>

      <!-- Danh sách khoá học -->      
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"></div>
    </div>`;

  return blockUI;
};

export const generalImageIntroduction = (data?: any) => {
  const blockUI = {
    id: "intro-img-block-id",
    label: "Phần ảnh giới thiệu",
    css: "",
    content: "",
    media: commonMedia,
    category: nameHeaderBlocks,
  };

  blockUI.content = `
    <div id="ikzvv" class="text-gray-600 body-font shadow-md">
      12312312312312313131231212312
    </div>
  `;

  return blockUI;
};
